import classNames from 'classnames';
import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import parser from 'html-react-parser'
import { Link } from 'gatsby'
import {
    section,

} from './ContentCards2.module.css'

export default function ContentCards2({ data }) {
    const { contentCards2ButtonText, contentCards2Text, contentCards2Title, contentCards2ButtonLink, contentCards2Cards, contentCards2ButtonExternalLinkButtonExternalLink } = data
    return (
        <div className={classNames('why-now-wrap', 'resource-case-wrp', section)}>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12 text-center mb-3'>
                        <figure className='case-study-icon'>
                            <StaticImage
                                src='../../../images/case-study-icon.png'
                                alt='image'
                            />
                        </figure>
                        <h2 className='heading-level-2 mb-2 blue-color'>
                            {contentCards2Title && parser(contentCards2Title)}
                        </h2>
                        <p>{contentCards2Text && parser(contentCards2Text)}</p>
                    </div>
                </div>

                <div className='row white-box-row'>
                    {contentCards2Cards?.map((block, i) => (
                        <div className='col-md-6 w-col-box' key={i}>
                            <div className='white-box-col-1 light-blue-col-2'>
                                <h4 className='heading-level-4-b'>
                                    {block.contentCards2CardTitle}
                                </h4>
                                <p>{block.contentCards2CardText && parser(block.contentCards2CardText)}</p>
                            </div>
                        </div>
                    ))}
                    <div className='col-md-12 text-center'>
                        {contentCards2ButtonExternalLinkButtonExternalLink ? (
                            <a href={contentCards2ButtonExternalLinkButtonExternalLink} className="btn blue-outline-btn">
                                {contentCards2ButtonText}
                            </a>
                        ) : contentCards2ButtonLink ? (
                            <Link
                                to={contentCards2ButtonLink.uri}
                                className='btn blue-outline-btn'
                            >
                                {contentCards2ButtonText}
                            </Link>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    )
}
